import { render, staticRenderFns } from "./ProductLibrary.vue?vue&type=template&id=19b88410&scoped=true&"
import script from "./ProductLibrary.vue?vue&type=script&lang=js&"
export * from "./ProductLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ProductLibrary.vue?vue&type=style&index=0&id=19b88410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b88410",
  null
  
)

export default component.exports